import React, { useEffect, useState } from 'react';
import {
    Box, Grid, Typography, Dialog, DialogTitle, DialogContent, DialogActions, Table, TableHead, TableBody, TableRow, TableCell, Radio, RadioGroup, Checkbox, Switch, IconButton,
} from '@mui/material';
import ButtonContained from '../../../Common/ButtonContained';
import CommonDropDown from '../../../Common/CommonDropDown';
import CommonTextField from '../../../Common/CommonTextField';
import { createFields, deleteFields, getDataById, updateFields } from '../../../../Redux/Actions/action';
import { showLoader } from '../../../../Redux/Slices/loaderSlice';
import ErrorHandler from '../../../../Utils/handler';
import { useDispatch } from 'react-redux';
import { addMemberEnum } from '../../../../Utils/enum';
import { toast } from 'react-toastify';
import DeleteIcon from '@mui/icons-material/Delete';
import TextLabel from '../../../Common/CommonTextLabel';
import { useConfirm } from 'material-ui-confirm';
import CommonTable from '../../../Common/CommonTable';
import StyledTableCell from '../../../Common/styledTableCell';
import CustomPagination from '../../../Common/CommonPagination';
import EditIcon from '@mui/icons-material/Edit';
import { UpdateSequenceComponent } from '../../../Common/UpdateSequenceComponent';

// Options for the dropdown
const options = [
    { label: "Personal Details", value: addMemberEnum.personalDetails },
    { label: "Id Proof Details", value: addMemberEnum.idProofDetails },
    { label: "Address Details", value: addMemberEnum.addressDetails },
    { label: "Address Proof Details", value: addMemberEnum.addressProofDetails },
    { label: "Village Details", value: addMemberEnum.villageDetails },
    { label: "Other Details", value: addMemberEnum.otherDetails },
    { label: "Nominee Details", value: addMemberEnum.nomineeDetails },
    { label: "Additional Details", value: addMemberEnum.additionalDetails },
];


export const actionEnum = [
    { label: "Text", value: "text" },
    { label: "Dropdown", value: "dropdown" },
    { label: "Number", value: "number" },
    { label: "Date", value: "date" },
    { label: "Tab", value: "tab" },
    { label: "File", value: "file" },
    { label: "Radio", value: "radio" },
]

function capitalizeFirstLetter(value) {
    if (typeof value !== 'string') return '';
    return value.charAt(0).toUpperCase() + value.slice(1);
}

const headerList = ["Sequence", "Field Name", "Define Action", "IsMandatory", "IsActive", "Edit", "Delete"]

const GeneralSection = () => {
    // ---------- Hook -----------
    const dispatch = useDispatch();
    const confirmDialogue = useConfirm();

    // --------------- State -------------
    const [selectedSection, setSelectedSection] = useState({});
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [newFieldValue, setNewFieldValue] = useState("");
    const [fields, setFields] = useState([
        {
            "name": "",
            "key": "",
            "type": "Text",
            "isActive": false,
            "isMandatory": false,
        }
    ]);
    const [fieldData, setFieldData] = useState([]);
    const [fieldUpdateDataId, setFieldUpdateDataId] = useState();
    const [error, setError] = useState();
    const [page, setPage] = useState(1);
    const [isEdit, setIsEdit] = useState(false);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [isSequence, setIsSequence] = React.useState({ indexNo: "", open: false })


    // --------------- handleChange ---------------
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(1);
    };

    const detailsHandler = (e) => {
        const value = e.target.value;
        const selected = options?.length > 0 && options?.find((e) => e.label == value)
        setSelectedSection(selected);
    };

    const handleOpenModal = () => {
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsEdit(false)
        setError('')
        setIsModalOpen(false);
        setNewFieldValue(""); // Clear the input when the modal is closed 
        setFields([{
            "name": "",
            "key": "",
            "type": "Text",
            "isActive": false,
            "isMandatory": false
        }]);
    };

    const convertToCaseSensitive = (value) => {
        if (typeof value !== 'string') return '';
        return value.toLowerCase().replace(/\s+(\w)/g, (_, letter) => letter.toUpperCase());
    };

    const validateSequence = (previousSequence) => {
        if (fields?.indexNo !== previousSequence) {
            return true
        } else {
            toast.error("Sequence you entered is same !");
            return false
        }
    }

    // -------------- API calling -------------
    const _getData = async () => {
        dispatch(showLoader(true))
        const body = {
            sectionIds: [selectedSection?.value?.toString()]
        }
        try {
            const result = await dispatch(getDataById(body))
            const error = ErrorHandler(result)
            if (error) {
                setFieldData(result?.payload?.data?.sections?.[0]?.fields)
                setFieldUpdateDataId(result?.payload?.data?.sections?.[0])
            }
        } catch (error) {
            console.log(error)
        } finally {
            dispatch(showLoader(false))
        }
    }

    // add Filed
    const _createFields = async () => {
        if (!fields?.[0]?.name) {
            setError({ fieldsName: "Please enter field name" });
            return;
        }
        const actionType = actionEnum?.find((val) => val?.label === fields?.[0]?.type)?.value
        dispatch(showLoader(true))
        const body = {
            "sectionId": selectedSection?.value?.toString(),
            "fieldKey": convertToCaseSensitive(fields?.[0]?.name),
            "fieldName": fields?.[0]?.name,
            "defineActionType": actionType,
            "isActive": fields?.[0]?.isActive,
            "isMandatory": fields?.[0]?.isMandatory,
        }
        if (isEdit) {
            // body._id = fields?.[0]?.id
            body.fieldKey = fields?.[0]?.key
        }
        try {
            const fn = isEdit ? updateFields : createFields
            const res = await dispatch(fn(body));
            const error = ErrorHandler(res)
            if (error) {
                toast.success(res?.payload?.message);
                setIsModalOpen(false);
                setIsEdit(false);
                setNewFieldValue("");
                setFields([{
                    "name": "",
                    "key": "",
                    "type": "Text",
                    "isActive": false,
                    "isMandatory": false
                }]);
                _getData();
            }
        } catch (error) {
            console.log(error)
        } finally {
            dispatch(showLoader(false))
        }
    }

    const _updateSequence = async (field) => {
        if (!validateSequence(isSequence?.indexNo)) {
            return;
        }
        dispatch(showLoader(true))
        const body = {
            // "_id": field?._id,
            "sectionId": selectedSection?.value?.toString(),
            "fieldKey": field?.fieldKey,
            "fieldName": field?.fieldName,
            "defineActionType": field?.defineActionType,
            "isActive": field?.isActive,
            "isMandatory": field?.isMandatory,
            "indexNo": +isSequence?.indexNo,
        }
        try {
            const result = await dispatch(updateFields(body))
            const error = ErrorHandler(result)
            if (error) {
                toast.success(result?.payload?.message);
                _getData()
            }
        } catch (error) {
            console.log(error)
        } finally {
            dispatch(showLoader(false))
        }
    }

    // update isMandatory & isActive
    const active_inactive = async (data, check, isBlock) => {
        dispatch(showLoader(true))
        const body = {
            // "_id": fieldUpdateDataId?._id,
            "fieldKey": data?.fieldKey,
            "fieldName": data?.fieldName,
            "sectionId": fieldUpdateDataId?.sectionId,
            "defineActionType": data?.defineActionType,
            "isMandatory": check === "isMandatory" ? isBlock : data?.isMandatory,
            "isActive": check === "isActive" ? isBlock : data?.isActive,
        }
        try {
            const res = await dispatch(updateFields(body));
            const error = ErrorHandler(res)
            if (error) {
                toast.success(res?.payload?.message);
                _getData()
            }
        } catch (error) {
            console.log(error)
        } finally {
            dispatch(showLoader(false))
        }
    }

    // delete
    const _deleteFiled = async (fieldKey) => {
        dispatch(showLoader(true));
        let body = {
            "fieldKey": fieldKey,
            "sectionId": fieldUpdateDataId?.sectionId,
        }
        try {
            const result = await dispatch(deleteFields(body));
            const error = ErrorHandler(result);
            if (error) {
                toast?.success(result?.payload?.message)
                _getData()
            }
        } catch (error) {
            console.log(error);
        } finally {
            dispatch(showLoader(false));
        }
    }

    // ---------------- useEffect ----------------
    useEffect(() => {
        if (selectedSection?.value) {
            _getData()
        }
    }, [selectedSection?.value, page, rowsPerPage]);

    useEffect(() => {
        if (options.length > 0) {
            setSelectedSection(options[0]);
        }
    }, []);

    return (
        <>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <Typography sx={{ fontSize: '20px', fontWeight: 500 }}>Registration Form</Typography>
                        <Box sx={{ display: 'flex', gap: '18px' }}>
                            <Box sx={{ minWidth: 220 }}>
                                <CommonDropDown
                                    width="100%"
                                    values={options.map((option) => option.label)}
                                    onChange={(e) => detailsHandler(e)}
                                    name="Details"
                                    defaultValue={"Easy"}
                                    value={selectedSection?.label}
                                    valid
                                    notShowSelect
                                />
                            </Box>

                            <ButtonContained
                                height={'39px'}
                                text={"Add New Field"}
                                onClick={handleOpenModal}
                            />
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={12}>
                    {/* Display saved table here */}
                    {/* {fieldData?.length > 0 && ( */}
                    <CommonTable
                        headerList={headerList}
                        minWidth={600}
                    >
                        {fieldData?.map((field, i) => (
                            <TableRow key={i}>
                                <StyledTableCell align='center'>
                                    <UpdateSequenceComponent
                                        isSequence={isSequence}
                                        setIsSequence={setIsSequence}
                                        index={i}
                                        value={field}
                                        onClick={() => {
                                            if (validateSequence(field?.indexNo)) {
                                                _updateSequence(field)
                                                setIsSequence({ open: false })
                                            }
                                        }}
                                    />
                                </StyledTableCell>
                                <StyledTableCell align='center'>{field?.fieldName}</StyledTableCell>
                                <StyledTableCell align='center'>{field?.defineActionType}</StyledTableCell>
                                <StyledTableCell align='center'>
                                    <Switch
                                        checked={field?.isMandatory}
                                        color="primary"
                                        onChange={(e) => {
                                            active_inactive(field, "isMandatory", e.target.checked);
                                        }} />
                                </StyledTableCell>
                                <StyledTableCell align='center'>
                                    <Switch
                                        checked={field?.isActive}
                                        color="primary"
                                        onChange={(e) => {
                                            active_inactive(field, "isActive", e.target.checked);
                                        }} />
                                </StyledTableCell>
                                <StyledTableCell align='center'>
                                    <IconButton onClick={() => {
                                        setIsEdit(true); setIsModalOpen(true); setFields([{
                                            "name": field?.fieldName,
                                            "key": field?.fieldKey,
                                            "type": capitalizeFirstLetter(field?.defineActionType),
                                            "isActive": field?.isActive,
                                            "isMandatory": field?.isMandatory,
                                            // "id": field?._id
                                        }]);
                                    }} >
                                        <EditIcon />

                                    </IconButton>
                                </StyledTableCell>
                                <StyledTableCell align='center'>
                                    <IconButton onClick={() =>
                                        confirmDialogue({
                                            title: `Are you sure you want to delete this field?`,
                                        })
                                            .then(() => {
                                                _deleteFiled(field?.fieldKey)
                                            })
                                            .catch((err) => { })} >
                                        <DeleteIcon />
                                    </IconButton>
                                </StyledTableCell>

                            </TableRow>
                        ))}

                    </CommonTable>
                    {/* )} */}
                    {fieldData?.count?.length > 0 &&
                        <Grid item xs={12}>
                            <CustomPagination
                                rowsPerPageOptions={[5, 10, 25, 50]}
                                count={Math.ceil(fieldData?.count / rowsPerPage)}
                                page={page}
                                onPageChange={handleChangePage}
                                rowsPerPage={rowsPerPage}
                                onRowsPerPageChange={handleChangeRowsPerPage} />

                        </Grid>
                    }
                </Grid>
            </Grid >

            {/* Modal with Table */}
            <Dialog open={isModalOpen} onClose={handleCloseModal} maxWidth="md" fullWidth >
                <DialogTitle>{isEdit ? 'Edit Fields' : 'Add Fields'}</DialogTitle>
                <DialogContent>
                    {/* <Box sx={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
                        <Box sx={{ display: 'flex', gap: '16px' }}>
                            <CommonTextField
                                label="Field Name"
                                fullWidth
                                value={newFieldValue}
                                onChange={(e) => setNewFieldValue(e.target.value)}
                                variant="outlined"
                            />
                            <ButtonContained text="Add" onClick={handleAddField} />
                        </Box>

                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Field Name</TableCell>
                                    <TableCell>Define Action</TableCell>
                                    <TableCell>Status</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {fields?.map((field) => (
                                    <TableRow key={field?.id}>
                                        <TableCell>{field?.name}</TableCell>
                                        <TableCell>
                                            <RadioGroup
                                                row
                                                value={field?.type}
                                                onChange={(e) =>
                                                    setFields((prevFields) =>
                                                        prevFields.map((f) =>
                                                            f.id === field?.id ? { ...f, type: e.target.value } : f
                                                        )
                                                    )
                                                }
                                            >
                                                {['Text', 'Number', 'Date', 'Attachment', 'Dropdown'].map((type) => (
                                                    <Box
                                                        key={type}
                                                        sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}
                                                    >
                                                        <Radio
                                                            value={type}
                                                            name={`define-action-${field?.id}`}
                                                            size="small"
                                                        />
                                                        <Typography variant="body2">{type}</Typography>
                                                    </Box>
                                                ))}
                                            </RadioGroup>
                                        </TableCell>
                                        <TableCell>
                                            <Box sx={{ display: 'flex', gap: 1 }}>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                                    <Checkbox
                                                        checked={field?.isActive}
                                                        disabled
                                                        onChange={(e) =>
                                                            setFields((prevFields) =>
                                                                prevFields.map((f) =>
                                                                    f.id === field.id ? { ...f, isActive: e.target.checked, } : f
                                                                )
                                                            )
                                                        }
                                                        size="small"
                                                    />
                                                    <Typography variant="body2">Active</Typography>
                                                </Box>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                                    <Checkbox
                                                        checked={field?.isMandatory}
                                                        onChange={(e) =>
                                                            setFields((prevFields) =>
                                                                prevFields.map((f) =>
                                                                    f.id === field.id ? { ...f, isMandatory: e.target.checked } : f
                                                                )
                                                            )
                                                        }
                                                        size="small"
                                                    />
                                                    <Typography variant="body2">Mandatory</Typography>
                                                </Box>
                                            </Box>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </Box> */}

                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
                        <Table sx={{ minWidth: 760 }}>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Field Name</TableCell>
                                    <TableCell>Define Action</TableCell>
                                    <TableCell>Status</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {fields?.map((field) => (
                                    <TableRow key={field?.id}>
                                        {console.log(field, 'newAkki')}
                                        <TableCell>
                                            <CommonTextField
                                                value={field?.name}
                                                placeholder={'Enter Field Name'}
                                                onChange={(e) =>
                                                    setFields((prevFields) =>
                                                        prevFields.map((f) =>
                                                            f.fieldKey === field?.fieldKey
                                                                ? { ...f, name: e.target.value }
                                                                : f
                                                        )
                                                    )
                                                }
                                                variant="outlined"
                                                size="small"
                                                fullWidth
                                            />
                                            <TextLabel color='error' title={!field?.name ? error?.fieldsName : ""} />
                                        </TableCell>

                                        <TableCell>
                                            <RadioGroup
                                                row
                                                value={field?.type}
                                                onChange={(e) =>
                                                    setFields((prevFields) =>
                                                        prevFields.map((f) =>
                                                            f.fieldKey === field?.fieldKey
                                                                ? { ...f, type: e.target.value }
                                                                : f
                                                        )
                                                    )
                                                }
                                            >
                                                {/* ['Text', 'Number', 'Date', 'File', 'Dropdown'] */}
                                                {actionEnum?.map((val, index) => (
                                                    <Box
                                                        key={index}
                                                        sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}
                                                    >
                                                        <Radio
                                                            value={val?.label}
                                                            name={`define-action-${field?.fieldKey}`}
                                                            size="small"
                                                        />
                                                        <Typography variant="body2">{val?.label}</Typography>
                                                    </Box>
                                                ))}
                                            </RadioGroup>
                                        </TableCell>

                                        <TableCell>
                                            <Box sx={{ display: 'flex', gap: 1 }}>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                                    <Checkbox
                                                        checked={field?.isActive}
                                                        disabled
                                                        onChange={(e) =>
                                                            setFields((prevFields) =>
                                                                prevFields.map((f) =>
                                                                    f.fieldKey === field.fieldKey
                                                                        ? { ...f, isActive: e.target.checked }
                                                                        : f
                                                                )
                                                            )
                                                        }
                                                        size="small"
                                                    />
                                                    <Typography variant="body2">Active</Typography>
                                                </Box>

                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                                    <Checkbox
                                                        checked={field?.isMandatory}
                                                        onChange={(e) =>
                                                            setFields((prevFields) =>
                                                                prevFields.map((f) =>
                                                                    f.fieldKey === field.fieldKey
                                                                        ? { ...f, isMandatory: e.target.checked }
                                                                        : f
                                                                )
                                                            )
                                                        }
                                                        size="small"
                                                    />
                                                    <Typography variant="body2">Mandatory</Typography>
                                                </Box>
                                            </Box>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </Box>

                </DialogContent>
                <DialogActions>
                    <ButtonContained onClick={handleCloseModal} text="Close" color="secondary" />
                    <ButtonContained text={isEdit ? "Update" : "Save"} onClick={_createFields} />
                </DialogActions>
            </Dialog>
        </>
    );
};

export default GeneralSection;

